export default __webpack_public_path__ + "static/media/TherapistOn.240003e4.svg";